import type { ComponentType } from "react";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { T } from "@freightsimple/ui-core/Typography/T";

interface AuthenticationAccountTypeCardProps {
  icon: ComponentType<{ className?: string }>;
  label: string;
}

/**
 * Inner content for an account-type ChoiceCard: a big icon in a soft rounded
 * tile above its label — button-like without the all-grey original look. Lives
 * in CustomComponents so it can use Tailwind (renovated feature code can't).
 */
export function AuthenticationAccountTypeCard({
  icon,
  label,
}: AuthenticationAccountTypeCardProps) {
  return (
    <div className="flex flex-col items-center gap-3 py-1">
      {/* Neutral grey tile at rest; fills brand when the card is selected (the
          card's `group` exposes its checked state). Pale enough that the icon,
          which stays dark, is still legible on top. */}
      <div className="flex size-16 items-center justify-center rounded-2xl bg-muted transition-colors group-data-[state=checked]:bg-brand/30">
        <Icon icon={icon} size="3xl" color="text-foreground" />
      </div>
      <T size="base" weight="medium" align="center">
        {label}
      </T>
    </div>
  );
}
